<bfx-autoComplete
  #autocompleteControl
  [(ngModel)]="data.value"
  [suggestions]="data.tenorValueDates"
  dataKey="value"
  field="label"
  [minLength]="1"
  [dropdown]="true"
  [label]="data.label"
  [inputEndContainer]="tenorValueDate"
  [fieldEndIcon]="[
        'bfx-ignore-target fa fa-fw icon_ion_chevron_down bfx-field-select-button-toggle',
        'bfx-ignore-target fa fa-fw icon-calendar_month'
      ]"
  (fieldIconClick)="onFieldIconClick($event, autocompleteControl, calendar)"
  [appendTo]="'body'"
  [disabled]="locked||data.allTenorValueDates==null"
  [autoHighlight]="true"
  [allowEmptySelection]="false"
  target="valueDate"
  [emptyIsInactive]="false"
  [skipSorting]="true"
  [showBar]="false"
  (onFocus)="onFocus($event)"
  (onSelect)="onSelect($event)"
  (onBlur)="onBlur($event)"
  (completeMethod)="searchTenors($event)"
  [bfxTooltip]="data.errorMsg"
  tooltipPosition="top"
  tooltipStyleClass="interface-control__good-from-until__tooltip"
  [tooltipDisabled]="!data.showError || inputFocused"
  [scrollHeight]="scrollHeight"
  [state]="data.state"
  [size]="'sm'"
>
  <ng-template #tenorValueDate>
    <div class="bfx-value-date-container">
      <a
        *ngIf="data.value&&data.value.tenor!=null"
        class="bfx-value-date-label"
        [attr.disabled]="locked||data.allTenorValueDates==null ? '' : null"
        (click)="tenorValueDateClick($event)"
        >{{(data.valueDate) ? (data.valueDate | date:'dd-MMM-yy') : ''}}</a
      >
    </div>
  </ng-template>
</bfx-autoComplete>

<bfx-calendar
  #calendar
  appendTo="body"
  class="manual-market__calendar__module"
  panelStyleClass="bfx-calendar__dropdown__container"
  dateFormat="DD-MMM-YYYY"
  nativeDesktopCalendar="valueDateCalendar"
  target="valueDateCalendar"
  [showIcon]="false"
  [adjustForTimeZone]="true"
  [hideOnDateTimeSelect]="true"
  [(ngModel)]="data.valueDate"
  [disabledDates]="data.holidays"
  [disabledDays]="[0,6]"
  [showActionsBar]="false"
  [showDateInput]="false"
  [minDateAdjustment]="0"
  [disabled]="locked||data.allTenorValueDates==null"
  [autoCompletePosition]="autocompleteControl"
  (dateValueInput)="showCalendarValue($event)"
  (onSelect)="brokenDateSelected($event)"
>
</bfx-calendar>
